module.exports = __webpack_public_path__ + "static/media/ce180-placeholder.998b58c9.png";